const { DateTime } = require('luxon')

function createCalendar (event) {
  const formatTime = function (date) {
    // eslint-disable-next-line new-cap
    const newDate = new DateTime.fromISO(date).setZone(
      'America/Detroit'
    )
    return newDate.toFormat("yyyyMMdd'T'HHmm'00'")
    /* Have: 2019-11-27T07:00:00.000
        Need: 20200219T090000
    // let dateFormatted = date.toISOString().replace(/-|:|\.\d\d\d/g, "")
    /* Remove the trailing Z to force use of time zone instead) */
    // return dateFormatted.substring(0, dateFormatted.length - 1)
  }

  const formatAddress = function (address) {
    if (typeof address !== 'undefined' && address !== null) {
      address = address.replace(/\\(.)/mg, '$1')
    }
    return address
  }

  const formatTZ = function (tz) {
    /* CraftQL returns time zone without slashes :-( */
    tz = tz.replace(/([a-z])([A-Z])/g, '$1/$2')
    return tz
  }

  const calendarGenerators = {
    google: function (event) {
      const startTime = formatTime(event.start)
      const endTime = formatTime(event.end)
      const tz = formatTZ(event.tz)

      const href = encodeURI([
        'https://www.google.com/calendar/render',
        '?action=TEMPLATE',
        '&text=' + (event.title || ''),
        '&ctz=' + (tz || ''),
        '&dates=' + (startTime || ''),
        '/' + (endTime || ''),
        '&details=' + (event.description || ''),
        '&location=' + formatAddress(event.address),
        '&sprop=&sprop=name:'
      ].join(''))
      return href
    },

    ics: function (event) {
      const startTime = formatTime(event.start)
      const endTime = formatTime(event.end)
      const tz = formatTZ(event.tz)

      const href = encodeURI(
        'data:text/calendar;charset=utf8,' + [
          'BEGIN:VCALENDAR',
          'VERSION:2.0',
          'BEGIN:VEVENT',
          'URL:' + document.URL,
          'DTSTART:' + (startTime || ''),
          'DTEND:' + (endTime || ''),
          'SUMMARY:' + (event.title || ''),
          'DESCRIPTION:' + (event.description || ''),
          'TZ:' + (tz || ''),
          'LOCATION:' + (event.address || ''),
          'END:VEVENT',
          'END:VCALENDAR'].join('\n'))
      return href
    },

    ical: function (event) {
      return this.ics(event)
    },

    outlook: function (event) {
      return this.ics(event)
    }
  }

  const generateCalendars = function (event) {
    return {
      google: calendarGenerators.google(event),
      ical: calendarGenerators.ical(event),
      outlook: calendarGenerators.outlook(event)
    }
  }

  const validParams = function (event) {
    return event !== undefined && event.start !== undefined &&
      (event.end !== undefined)
  }

  if (!validParams(event)) {
    console.log('Event details missing.')
    return
  }

  return generateCalendars(event)
}

function formatEventDates (startDate, endDate) {
  const start = DateTime.fromISO(startDate).setZone(
    'America/Detroit'
  )
  let end =
    endDate == null
      ? start
      : DateTime.fromISO(endDate).setZone('America/Detroit')
  if (start.hour === 0 && end.hour === 0) {
    end = end.minus({ days: 1 })
  }
  if (start.hasSame(end, 'day')) {
    return start.toLocaleString({ month: 'short', day: 'numeric' })
  } else if (!start.hasSame(end, 'year')) {
    return (
      start.toLocaleString({
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }) +
      ' - ' +
      end.toLocaleString({
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    )
  } else if (!start.hasSame(end, 'month')) {
    return (
      start.toLocaleString({ month: 'short', day: 'numeric' }) +
      ' - ' +
      end.toLocaleString({ month: 'short', day: 'numeric' })
    )
  } else if (!start.hasSame(end, 'day')) {
    return (
      start.toLocaleString({ month: 'short', day: 'numeric' }) +
      ' - ' +
      end.toLocaleString({ day: 'numeric' })
    )
  }
}

function formatEventTimes (startDate, endDate) {
  const start = DateTime.fromISO(startDate).setZone(
    'America/Detroit'
  )
  const end =
    endDate == null
      ? start
      : DateTime.fromISO(endDate).setZone('America/Detroit')

  if (start.hour === 0 && end.hour === 0) {
    return null
  }
  if (start.hasSame(end, 'millisecond') && start.minute === 0) {
    return start.toFormat('ha').toLowerCase()
  }
  if (start.hasSame(end, 'millisecond')) {
    return start.toFormat('h:mm a').toLowerCase()
  }

  let startString = ''
  let endString = ''

  startString =
    start.minute === 0 ? start.toFormat('h') : start.toFormat('h:mm')
  endString = end.minute === 0 ? end.toFormat('ha').toLowerCase() : end.toFormat('h:mma').toLowerCase()

  if (start.toFormat('H') < 12 && end.toFormat('H') >= 12) {
    startString += start.toFormat('a').toLowerCase()
  }

  return startString + '-' + endString
}

export { createCalendar, formatEventDates, formatEventTimes }
